module.exports = __webpack_public_path__ + "static/media/211CS115.5e596849.jpeg";